import { AnalyticsBrandSettings, AnalyticsEventData } from 'idt-analytics-api/models';
import { getDefaultAnalytics } from '../helpers/events.helper';
import { AnalyticsGTMSettings, DefaultAnalyticsSettings } from 'analytics-api';
import { AnalyticsOyshoEventDataHelpers } from '../helpers/brand-analytics-event-data.helpers.oy';
import { AnalyticsOyshoEventsTransformer } from '../helpers/brand-analytics-events.transformer.oy';

export const ResetPasswordEvents: AnalyticsBrandSettings = {

  recuperarContrasenaPerfilCompradorErrorRecuperarContrasena(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const field = componentData.field;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'perfil_comprador', 'recuperar_contrasena', 'error_recuperar_contrasena', field
    );
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  recuperarContrasenaPerfilUsuarioErrorRecuperarContrasena(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const field = componentData.field;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'perfil_usuario', 'recuperar_contrasena', 'error_recuperar_contrasena', field
    );
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  recuperarContrasenaPerfilCompradorErrorServidorRecuperarContrasena(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const cod = componentData.errorCode;
    const desc = componentData.errorDescription;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'perfil_comprador', 'recuperar_contrasena', 'error_servidor_recuperar_contrasena', `cod_${cod}-desc_${desc}`
    );
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  recuperarContrasenaPerfilUsuarioErrorServidorRecuperarContrasena(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData } = data;
    const cod = componentData.errorCode;
    const desc = componentData.errorDescription;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'perfil_usuario', 'recuperar_contrasena', 'error_servidor_recuperar_contrasena', `cod_${cod}-desc_${desc}`
    );
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  recuperarContrasenaPerfilUsuarioModificarContrasenaOk(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { helpers } = data;
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'perfil_usuario', 'recuperar_contrasena', 'modificar_contrasena_ok'
    );
    let settingsGTM: AnalyticsGTMSettings = AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
    const dimensions: string [] = ['38', '55', '59', '68', '88', '89'];
    if (isDefined(helpers)) {
      settingsGTM = AnalyticsOyshoEventsTransformer.fillAnalyticsDimensions(settingsGTM, dimensions, data);
    }
    return settingsGTM;
  },

  recuperarContrasenaPerfilCompradorRecuperarContrasenaOk(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'perfil_comprador', 'recuperar_contrasena', 'recuperar_contrasena_ok'
    );
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  recuperarContrasenaPerfilUsuarioRecuperarContrasenaOk(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'perfil_usuario', 'recuperar_contrasena', 'recuperar_contrasena_ok'
    );
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  recuperarContrasenaPerfilUsuarioRegistrarse(data: AnalyticsEventData): AnalyticsGTMSettings {
    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics(
      'analyticsEvent', 'perfil_usuario', 'recuperar_contrasena', 'registrarse'
    );
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

};
